<template>
  <div>
    <v-dialog v-model="value" persistent>
      <v-card>
        <v-layout style="flex-wrap: wrap-reverse;" justify-end>
          <v-flex class="pa-2 form-control" style="max-width: 300px">
            <multiselect
              v-model="papersize"
              :options="papersizeOptions"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
            ></multiselect>
            <!-- <select v-model="papersize" style="display: inline-block">
              <option v-for="option in papersizeOptions" :key="option" :value="option">
                {{ option }}
              </option>
            </select> -->
          </v-flex>
          <v-flex>
            <v-btn
              :loading="loading"
              color="primary"
              class="ma-2"
              :href="allOrderGroupId"
              target="_blank"
            >
              <v-icon class="mr-1">download</v-icon>Download
            </v-btn>
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="closePreview"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-text>
          <!-- <div class="text-xs-center my-4" v-show="!showPreview">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div v-show="showPreview"> -->
          <div v-if="papersize == 'paperang'" class="text-xs-center">
            <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
              >{{ $t('Link Copied') }}!</v-snackbar
            >
            <div style="max-width: 300px;margin: auto">
              <img
                src="/static/img/assets/shop/paperang.jpeg"
                style="width: 100%; max-width: 200px; margin: auto"
              />
              <textarea
                class="form-control pa-1"
                ref="shareLink"
                style="resize: vertical; width: 100%;margin: auto; border: 1px solid #eee;"
                onclick="this.select()"
                readonly="true"
                :value="pdfUrl + `&size=${papersize}`"
              ></textarea>
              <div class="text-xs-center">
                <v-btn
                  depressed
                  color="primary"
                  v-clipboard:copy="pdfUrl + `&size=${papersize}`"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <v-icon class="mr-2">content_copy</v-icon>

                  {{ $t('copy link') }}
                </v-btn>
              </div>
              <div class="text-xs-center mt-3 font-weight-bold">ขั้นตอนการใช้งาน Paperang</div>
              <div class="text-xs-left mb-3">
                1. กดคัดลอก URL <br />
                2. เปิด App Paperang เลือกเมนู พิมพ์หน้าเว็บ <br />
                3. วาง URL<br />
                4. สั่งปริ้นท์เลย
              </div>
            </div>
            <v-divider class="mt-3 mb-3" v-if="papersize !== 'paperang'"></v-divider>
          </div>
          <div
            style="border: 1px solid #eee"
            class="ma-auto"
            :style="{ 'max-width': '100%' }"
            v-if="papersize !== 'paperang'"
          >
            <embed
              @load="onPreviewLoad"
              :key="papersize"
              :src="allOrderGroupId"
              style="width: 100%; height: 500px; margin: 0px; padding: 0px;"
            />
          </div>
          <!-- </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import config from '@/config'
import { mapGetters } from 'vuex'
import PDFMerger from 'pdf-merger-js/browser'
export default {
  props: ['value', 'purchase_id', 'currentGroupId'],
  data() {
    return {
      showPreview: false,
      papersizeOptions: [
        'A4',
        'A5',
        'A6',
        'letter',
        'letter4x6',
        'sticker',
        'sticker4x6',
        'paperang'
      ],
      papersize: 'sticker4x6',
      showCopy: false,
      ordersGroupId: [],
      allOrderGroupId: '',
      pdfUrl: '',
      loading: false
    }
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      addresses: 'getShippingAddress'
    })
  },
  mounted() {
    const vm = this
    vm.pdflink()
  },

  methods: {
    async pdflink() {
      const vm = this
      vm.loading = true
      var replace_address = ''
      if (vm.addresses && vm.addresses.length > 0) {
        var selectedAddress = vm.addresses.find(el => {
          return el.selected === true
        })
        if (selectedAddress && selectedAddress.returnAddress) {
          var address = {
            ...selectedAddress.returnAddress,
            address: selectedAddress.returnAddress.addressno
          }
          replace_address = encodeURIComponent(JSON.stringify(address))
        }
      }
      vm.ordersGroupId = []

      if (typeof vm.currentGroupId === 'undefined') {
        vm.allOrderGroupId =
          `${config.serverUrl}shippop/print_cover?pageid=${this.selectedBot.pageid}&purchase_id=${this.purchase_id}&size=${this.papersize}` +
          (replace_address != '' ? `&replace_address=${replace_address}` : '')
      } else {
        // shippopaddresslabel
        vm.currentGroupId.forEach(item => {
          vm.ordersGroupId.push(
            `${config.serverUrl}shippop/print_cover?pageid=${vm.selectedBot.pageid}&purchase_id=${item.purchase_id}&size=${vm.papersize}` +
              (replace_address != '' ? `&replace_address=${replace_address}` : '')
          )
        })

        // vm.pdfUrl = `${config.serverUrl}shippop/print_cover?pageid=${vm.selectedBot.pageid}&purchase_id=${this.purchase_id}`
        vm.allOrderGroupId = await vm.dowloadPdf(vm.ordersGroupId)
      }
      vm.pdfUrl = `${config.serverUrl}shippop/print_cover?pageid=${this.selectedBot.pageid}&purchase_id=${this.purchase_id}`
      vm.loading = false
      return vm.allOrderGroupId
    },
    async dowloadPdf(ordersGroupId) {
      const vm = this

      const merger = new PDFMerger()

      for (const file of ordersGroupId) {
        await merger.add(file)
      }

      const mergedPdf = await merger.saveAsBlob()

      const blob = new Blob([mergedPdf], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      // link.click()
      // URL.revokeObjectURL(link.href)
      return link.href
    },
    onPreviewLoad() {
      this.showPreview = true
    },
    closePreview() {
      this.$emit('closePreview')
      this.$emit('input', false)
    },
    onCopy: function() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onError: function() {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PreviewShippopCover.vue